import { render, staticRenderFns } from "./page-transferOrder-view.vue?vue&type=template&id=4d719b9c&scoped=true&"
import script from "./page-transferOrder-view.vue?vue&type=script&lang=js&"
export * from "./page-transferOrder-view.vue?vue&type=script&lang=js&"
import style0 from "./page-transferOrder-view.vue?vue&type=style&index=0&id=4d719b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d719b9c",
  null
  
)

component.options.__file = "page-transferOrder-view.vue"
export default component.exports